module.exports = __webpack_public_path__ + "static/media/next-button.00cfad1f.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/next-button.svg
// module id = 405
// module chunks = 0